export const EMPLOYMENT_FIELD_SIDES = {
    DOCUMENT: { value: "DOCUMENT", text: "문서편집", color: "grey" },
    // EMPLOYER: { value: "EMPLOYER", text: "고용인", color: "primary" },
    EMPLOYEE: { value: "EMPLOYEE", text: "피고용인", color: "secondary" },
};

export const EMPLOYMENT_FIELD_TYPES = {
    TEXT: { value: "TEXT", text: "텍스트", icon: "mdi-format-text" },
    DATE: { value: "DATE", text: "날짜", icon: "mdi-calendar-blank" },
    CBOX: { value: "CBOX", text: "체크박스", icon: "mdi-checkbox-outline" },
    SIGN: { value: "SIGN", text: "사인·도장", icon: "mdi-signature-freehand" },
    FILE: { value: "FILE", text: "첨부파일 요청" },
};
